import Header from "../components/dashboard/Header";
import DoorsPanel from "../components/DoorsPanel";
import { WifiPanel } from "../components/WifiPanel";

export default function Doors() {
  return (
    <div className="min-h-screen bg-brand-page">
      <Header />
      <main className="max-w-[1600px] mx-auto px-6 lg:px-12 py-10">
        <div className="mb-8">
          <h1 className="font-serif text-4xl sm:text-5xl text-brand-ink tracking-tight" data-testid="doors-title">Doors</h1>
          <p className="text-sm text-brand-muted mt-2">
            Remote door access via Kisi — unlock doors, trigger a lockdown, and review the access log per location.
            Every unlock is logged with your name.
          </p>
        </div>
        <DoorsPanel showHeaders />
        <div className="mt-14"><WifiPanel /></div>
      </main>
    </div>
  );
}
